import { render } from "./AnnotationActionButtons.vue?vue&type=template&id=1ca87cbe&scoped=true"
import script from "./AnnotationActionButtons.vue?vue&type=script&lang=js"
export * from "./AnnotationActionButtons.vue?vue&type=script&lang=js"

import "../../assets/scss/annotation_action_buttons.scss?vue&type=style&index=0&id=1ca87cbe&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca87cbe"]])

export default __exports__